import React, { useState } from "react";
import { QuestionMarkCircleIcon } from "@heroicons/react/outline";
import { ButtonBase } from "@reusejs/react";
import { useRouter } from "next/router";
import { useSelector, useDispatch } from "react-redux";
import { clearBankerAuth } from "store";
import RightSidbar from "./rightSideBar";

export default function RightNavButtons(props: any) {
  const router = useRouter();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    dispatch(clearBankerAuth());
    router.push(`${process.env.NEXT_PUBLIC_WEB_URL}logout`);
  };

  return (
    <>
      {/* <div className="hidden lg:flex flex-row mr-4 items-center rounded"> */}
      {/* <ButtonBase
          variant="primary"
          type="submit"
          label="Logout"
          onClick={() => handleLogout()}
          buttonBaseClasses={{
            font: "text-sm font-medium",
            backgroundColor: "bg-blue-600 hover:bg-blue-700",
            textColor: "text-white",
            border: "any",
            width: "sm:w-full",
            padding: "px-2 py-2",
          }}
        /> */}
      {/* </div> */}
      <div className="">
        <span className="sr-only">Open main menu</span>
        <button
          type="button"
          onClick={() => {
            setIsOpen(true);
          }}
        >
          <QuestionMarkCircleIcon className="h-6 w-6 sm:h-8 sm:w-8 text-gray-400 hover:text-blue-600" />
        </button>
      </div>
      <RightSidbar isOpen={isOpen} setIsOpen={setIsOpen}>
        <div className="text-center h-full">Do you need any help?</div>
      </RightSidbar>
    </>
  );
}
